var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-info-text"},[_c('div',{staticClass:"-script-container"},[_c('textarea',{staticClass:"-script-input recoder-input-target",attrs:{"dir":"auto","placeholder":_vm.isAiVoiceType
          ? 'Type in your script...'
          : 'Type in your script (optional)...',"disabled":_vm.isRecording},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})])])}
var staticRenderFns = []

export { render, staticRenderFns }